import styled from 'styled-components';

const Footer = () => {
    return (
        <Wrap>
            <div className="con">
                <div className="top-box flex aic jcsb">
                    <span className="logo-box img-box">
                        <img src="./img/keyclops_logo.svg" alt="" />
                    </span>
                    <a className='shortcut-btn flex aic' href='/Keyclops_company.pdf' target='_blank'>
                        <span className="img-box">
                            <img src="./img/ico_pdf_fff.svg" alt="" />
                        </span>
                        <span className="text">회사소개서 보기</span>
                    </a>
                </div>
                <div className="line"></div>
                <ul className='infor-box-1 infor-box flex aic fww'>
                    <li className='flex'>
                        <h3>회사명</h3>
                        <p className='tsb'>키클롭스㈜</p>
                    </li>
                    <li className="line"></li>
                    <li className='flex'>
                        <h3>CEO</h3>
                        <p className='tsb'>박재현, 이현수</p>
                    </li>
                    <li className="line"></li>
                    <li className='flex'>
                        <h3>사업자 등록번호</h3>
                        <p className='tsb'>411-81-93483</p>
                    </li>
                    <li className="line"></li>
                    <li className='flex'>
                        <h3>E-MAIL</h3>
                        <p className='tsb'>
                            <a href="mailto:jhpark@keyclops.com">jhpark@keyclops.com</a>
                        </p>
                    </li>
                    <li className="line"></li>
                    <li className='flex'>
                        <h3>TEL</h3>
                        <p className='tsb'><a href="tel:0428223306">042 ) 822-3306</a></p>
                    </li>
                    <li className="line"></li>
                    <li className='flex'>
                        <h3>FAX</h3>
                        <p className='tsb'>042 ) 822-3308</p>
                    </li>
                </ul>
                <ul className='infor-box-2 infor-box flex aic fww'>
                    <li className='flex'>
                        <h3>Address</h3>
                        <p className='tsb'>대전광역시 유성구 복용동로 43(도안 더리브시그니처), F440호</p>
                    </li>
                </ul>
                <p className="copyright">Copyright © <span className="inblock tb">Keyclops Corp</span>, All rights reserved.</p>
            </div>
        </Wrap>
    );
}

export default Footer;

const Wrap = styled.div`
    width: 100%;
    box-sizing: border-box;
    padding: 20px 0;
    background: #00143E;
    @media (max-width: 1400px) {
        padding: 1.4285vw 0;
    }
    @media (max-width: 767px) {
        padding: 20px 0;
    }

    .con {
        .top-box {
            @media (max-width: 767px) {
                flex-direction: column;
                gap: 24px;
            }

            .logo-box {
                width: 124px;
                @media (max-width: 1400px) {
                    width: 8.8571vw;
                }
                @media (max-width: 1400px) {
                    width: 124px;
                }
            }

            .shortcut-btn {
                gap: 4px;
                box-sizing: border-box;
                padding: 10px 16px;
                border-radius: 8px;
                border: 1px solid #C8C8C8;
                @media (max-width: 1400px) {
                    gap: 0.2857vw;
                    padding: 0.7142vw 1.1428vw;
                    border-radius: 0.5714vw;
                }
                @media (max-width: 767px) {
                    gap: 4px;
                    padding: 10px 16px;
                    border-radius: 8px;
                }

                > .img-box {
                    width: 20px;
                    @media (max-width: 1400px) {
                        width: 1.4285vw;
                    }
                    @media (max-width: 767px) {
                        width: 20px;
                    }
                }

                > .text {
                    font-size: 14px;
                    line-height: 20px;
                    color: #FAFAFA;
                    @media (max-width: 1400px) {
                        font-size: 1vw;
                        line-height: 1.4285vw;
                    }
                    @media (max-width: 767px) {
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
            }
        }

        > .line {
            width: 100%;
            height: 0.5px;
            background: #A0A0A0;
            margin: 12px 0;
            @media (max-width: 1400px) {
                margin: 0.8571vw 0;
            }
            @media (max-width: 767px) {
                margin: 12px 0 24px 0;
            }
        }

        .infor-box {
            gap: 12px;
            @media (max-width: 1400px) {
                gap: 0.8571vw;
            }
            @media (max-width: 767px) {
                gap: 10px;
                row-gap: 8px;
                justify-content: center;
            }
            &.infor-box-2 {
                margin-top: 8px;
                @media (max-width: 1400px) {
                    margin-top: 0.5714vw;
                }
                @media (max-width: 767px) {
                    margin-top: 8px;
                }
            }

            > li {
                gap: 12px;
                @media (max-width: 1400px) {
                    gap: 0.8571vw;
                }
                @media (max-width: 767px) {
                    gap: 12px;
                }
                &.line {
                    width: 1px;
                    height: 15px;
                    background: #fff;
                    @media (max-width: 1400px) {
                        height: 1.0714vw;
                    }
                    @media (max-width: 767px) {
                        display: none;
                    }
                }

                h3 {
                    font-size: 16px;
                    line-height: 24px;
                    color: #C8C8C8;
                    @media (max-width: 1400px) {
                        font-size: 1.1428vw;
                        line-height: 1.7142vw;
                    }
                    @media (max-width: 767px) {
                        font-size: 16px;
                        line-height: 24px;
                    }
                }

                p, p > a {
                    font-size: 16px;
                    line-height: 24px;
                    color: #FAFAFA;
                    @media (max-width: 1400px) {
                        font-size: 1.1428vw;
                        line-height: 1.7142vw;
                    }
                    @media (max-width: 767px) {
                        font-size: 16px;
                        line-height: 24px;
                    }
                }
            }
        }

        .copyright {
            margin-top: 24px;
            font-size: 14px;
            line-height: 20px;
            color: #A0A0A0;
            @media (max-width: 1400px) {
                margin-top: 1.7142vw;
                font-size: 1vw;
                line-height: 1.4285vw;
            }
            @media (max-width: 767px) {
                margin-top: 24px;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
            }

            > span {
                line-height: 20px;
                @media (max-width: 1400px) {
                    line-height: 1.4285vw;
                }
                @media (max-width: 767px) {
                    line-height: 20px;
                }
            }
        }
    }

`